import { render } from "./OperatorPanel.vue?vue&type=template&id=5e64516e&scoped=true"
import script from "./OperatorPanel.vue?vue&type=script&lang=js"
export * from "./OperatorPanel.vue?vue&type=script&lang=js"

import "./OperatorPanel.vue?vue&type=style&index=0&id=5e64516e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e64516e"]])

export default __exports__